import countryCode from './data/country-code-emoji.json';
const alternateName = {
    "Russian Federation": "Russia",
    "UK": "United Kingdom",
    "United Kingdom of Great Britain and Northern Ireland": "United Kingdom",
    "United States of America": "United States",
    "US": "United States",
    "TRINIDAD AND TOBAGO": "Trinidad & Tobago",
    "BRUNEI DARUSSALAM": "Brunei",
    "Tanzania, United Republic of": "Tanzania",
    "Trinidad and Tobago": "Trinidad & Tobago",
    "São Tomé and Príncipe": "São Tomé & Príncipe"
}
export default function getCountryFlag(countryName) {
    if (alternateName[countryName] !== undefined) {
        countryName = alternateName[countryName];
    }
    let returVal = null;
    for (const country of countryCode) {
        if (country.name.toLowerCase() === countryName.toLowerCase()) {
            returVal = country.code;
            break;
        }
    }
    return returVal;
}
